import {
  IdentityParameter,
  PageNumberBasedListRequest,
} from "@/features/types";
import { LineSheet } from "@/features/line-sheet-sets/line-sheet-set.types";
import { calcIdentityUrlPrefix } from "@/features/ui/helpers/fetcher-helpers";
import useSWR, { SWRConfiguration } from "swr";
import useFetcher from "@/utils/use-fetcher";

export interface ListLineSheetsRequest extends PageNumberBasedListRequest {
  query?: string;
  "madeByCompany.id__in"?: number[];
  season__in?: string[];
}

export interface ListLineSheetsResponse extends Omit<LineSheet, "lineSheets"> {
  totalCount: number;
  lineSheets: LineSheet[];
}

export interface ListLineSheetsPathParameter extends IdentityParameter {
  lineSheetSetId: number;
}

export function getListLineSheetsKey(
  parameter: ListLineSheetsPathParameter,
  request?: ListLineSheetsRequest
) {
  const { lineSheetSetId } = parameter;
  let url = calcIdentityUrlPrefix(parameter);
  url += `/line-sheet-sets/${lineSheetSetId}/line-sheets`;
  return {
    url,
    params: request,
  };
}

export default function useListLineSheets(
  parameter: ListLineSheetsPathParameter,
  request: ListLineSheetsRequest = { pageSize: 500, pageNumber: 1 },
  config: SWRConfiguration = {
    revalidateOnFocus: false,
  }
) {
  const fetcher = useFetcher<ListLineSheetsRequest, ListLineSheetsResponse>();
  return useSWR(getListLineSheetsKey(parameter, request), fetcher, config);
}
